import { Loader, Stack } from 'component-library';
import { Suspense } from 'react';

import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';
import { NaturalCapitalDimension } from '@/api/rest/resources/types/organization';
import { useIndicatorProduct } from '@/hooks/useIndicatorProduct';
import { useNaturalCapitalAccount } from '@/hooks/useNaturalCapitalAccount';

import { NaturalCapitalTable } from './NaturalCapitalTable';

export const NaturalCapitalTables = () => {
  const data = useNCAData();

  return (
    <Suspense fallback={<Loader size={8} className='min-h-[200px]' />}>
      <Stack direction='col' spacing={6} className='w-full'>
        {data.map((landUseData) => (
          <NaturalCapitalTable key={landUseData.land_type} {...landUseData} />
        ))}
      </Stack>
    </Suspense>
  );
};

const useNCAData = () => {
  const data = useNaturalCapitalAccount().data?.land_type_nca ?? [];

  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];
  const hasEsaIP = purchasedIndicatorProducts.some(
    (ip) => INDICATOR.ESA_ABOVE_GROUND_CARBON === ip.name && ip.purchased_at,
  );

  if (!hasEsaIP) {
    return data;
  }

  return data.map((d) => ({
    ...d,
    data: d.data.filter((entry) => entry.dimension !== NaturalCapitalDimension.CARBON),
  }));
};
